export const endpoints = {
  changeImageProfile: '/user/image',
}
